import React, { useRef, useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { Button } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import L from 'leaflet'; // 1. Import the core Leaflet library

function FullscreenButton() {
  const map = useMap();
  const buttonRef = useRef(null); // 2. Create a ref for the button element

  // 3. This effect runs once and adds event listeners
  useEffect(() => {
    if (buttonRef.current) {
      // 4. This is the Leaflet-specific function to stop
      // click events from propagating to the map.
      L.DomEvent.disableClickPropagation(buttonRef.current);
      L.DomEvent.disableScrollPropagation(buttonRef.current);
    }
  }, []); // Empty array so it only runs once

  const handleClick = () => {
    if (map.getContainer()) {
      map.getContainer().requestFullscreen();
    }
  };

  return (
    <Button
      ref={buttonRef} // 5. Attach the ref to the button
      variant="contained"
      onClick={handleClick}
      sx={{
        position: 'absolute',
        top: 85, // Moved down below zoom
        left: 10,
        zIndex: 1000, 
        backgroundColor: 'white',
        color: 'black',
        padding: '6px',
        minWidth: 'auto',
        '&:hover': {
          backgroundColor: '#f4f4f4'
        }
      }}
    >
      <FullscreenIcon />
    </Button>
  );
}

export default FullscreenButton;